import React, { useMemo } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { Box } from "@mui/material";
import { orderStatusColors } from "../OrderStatusColors/orderStatusColors";


interface orderStatusOverview {
    status: string;
    count: string;
}
interface DonutChartProps {
    data: orderStatusOverview[];
}

const DonutChart :React.FC<DonutChartProps> = ({data}) => {
    // const data = useMemo(
    //     () => [
    //         {
    //             label: "PENDING",
    //             value: 12,
    //             color: orderStatusColors.PENDING.color,
    //         },
    //         {
    //             label: "APPROVED",
    //             value: 25,
    //             color: orderStatusColors.APPROVED.color,
    //         },
    //         {
    //             label: "PROCESSING",
    //             value: 18,
    //             color: orderStatusColors.PROCESSING.color,
    //         },
    //         {
    //             label: "COMPLETED",
    //             value: 45,
    //             color: orderStatusColors.COMPLETED.color,
    //         },
    //     ],
    //     []
    // );

    const total = data.reduce(
        (sum:any, item:orderStatusOverview) => sum + Number(item.count),
        0
    );

    const chartKey = `order-status-${total}-${data
        .map((item:orderStatusOverview) => `${item.status}:${item.count}`)
        .join("|")}`;

    const options: ApexOptions = {
        chart: {
            type: "donut",
            toolbar: {
                show: false,
            },
        },

        labels: data.map((item:orderStatusOverview) => item.status),

        legend: {
            show: false,
        },

        colors: data.map((item:orderStatusOverview) => orderStatusColors?.[item?.status].color),

        dataLabels: {
            enabled: false,
        },

        stroke: {
            width: 2,
            colors: ["#F7F3EB"],
        },

        plotOptions: {
            pie: {
                customScale: 0.9,

                donut: {
                    size: "72%",

                    labels: {
                        show: true,

                        name: {
                            show: true,
                            fontSize: "14px",
                        },

                        value: {
                            show: true,
                            fontSize: "28px",
                            fontWeight: 600,
                            formatter: () => `${total}`,
                        },

                        total: {
                            show: true,
                            showAlways: true,
                            label: "Total Orders",
                            formatter: () => `${total}`,
                        },
                    },
                },
            },
        },
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent:'center',
                flexDirection:{xs:'column',md:'row'},
                gap: 0,
                width: "100%",
            }}
        >
            <Box
                className="m-0 p-0"
                sx={{width:{xs:"100%",md:"75%"}}}
            >
                <Chart
                    key={chartKey}
                    options={options}
                    series={data.map((item:orderStatusOverview) => Number(item.count))}
                    type="donut"
                    width="100%"
                />
            </Box>

            <div
                style={{
                    flex: 1,
                }}
            >
                {data.map((item) => {
                    const percentage =
                        total > 0
                            ? Math.round((Number(item.count) / total) * 100)
                            : 0;

                    return (
                        <div
                            key={item.status}
                            style={{
                                display: "grid",
                                gridTemplateColumns:
                                    "18px 1fr 40px 55px",
                                alignItems: "center",
                                columnGap: 0,
                                marginBottom: 8,
                            }}
                        >
                            <span
                                style={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: "50%",
                                    background: orderStatusColors?.[item?.status].color,
                                }}
                            />

                            <span
                                style={{
                                    fontSize: "14px",
                                    color: "#222",
                                    textTransform: "capitalize",
                                }}
                            >
                                {item.status.toLowerCase()}
                            </span>

                            <span
                                style={{
                                    textAlign: "right",
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    color: orderStatusColors?.[item?.status]?.color,
                                }}
                            >
                                {item.count}
                            </span>

                            <span
                                style={{
                                    textAlign: "right",
                                    color: "#666",
                                    fontSize: "14px",
                                }}
                            >
                                ({percentage}%)
                            </span>
                        </div>
                    );
                })}
            </div>
        </Box>
    );
};

export default DonutChart;